
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zvvnbczckdevzzgexncb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp2dm5iY3pja2Rldnp6Z2V4bmNiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDczMjc0MjgsImV4cCI6MjA2MjkwMzQyOH0.9DWUdbT4rI3jCO39QRctT83fO5yHqr_zveNilygKDYk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Log the connection details to verify they're being used
console.log('🔌 Supabase client initialized from integrations/supabase/client.ts');
